<script setup lang="ts">
import type { BaseItem } from '~/models/Content/BaseItem'
import ProductSearchSkeleton from '~/components/skeletons/ProductSearchSkeleton.vue'
import BookCard from '~/components/cards/BookCard.vue'

defineProps<{
  results: BaseItem[]
  isLoading: boolean
  productTitle: string
}>()
</script>

<template>
  <ProductSearchSkeleton v-if="isLoading" />
  <ul
    v-else
    class="grid auto-rows-max grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
  >
    <li
      v-for="result in results"
      :key="`book-${result.locationId}`"
      class="row-span-2 grid grid-rows-subgrid"
    >
      <BookCard :item="result" />
    </li>
  </ul>
</template>
